import { useCallback, useState } from 'react';

import { TypewriterOnce } from '../../components/TypewriterOnce';

import { ProviderPickList } from './ProviderPickList';
import { type Provider } from './providers';

type MemoryImportSelectScreenProps = {
	websiteUrl?: string | null;
	instagramHandle?: string | null;
	onPick: (provider: Provider) => void;
	onSkip: () => void;
};

export const MemoryImportSelectScreen = ({
	websiteUrl,
	instagramHandle,
	onPick,
	onSkip,
}: MemoryImportSelectScreenProps) => {
	const [typingDone, setTypingDone] = useState(false);
	const handleTypingDone = useCallback(() => setTypingDone(true), []);

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="w-full max-w-[760px] px-8">
				<h2
					className="mb-4"
					style={{
						fontSize: 'clamp(26px, 4vw, 40px)',
						fontWeight: 700,
						letterSpacing: '-0.02em',
						lineHeight: 1.15,
						color: 'var(--text-primary)',
					}}
				>
					<TypewriterOnce
						text="Here's how to get your work over to me."
						onDone={handleTypingDone}
					/>
				</h2>

				<div
					style={{
						opacity: typingDone ? 1 : 0,
						transition: 'opacity 400ms ease',
						pointerEvents: typingDone ? 'auto' : 'none',
					}}
				>
					<p
						className="mb-8"
						style={{
							fontSize: 18,
							lineHeight: 1.5,
							color: 'var(--text-primary)',
						}}
					>
						Already worked with another AI on your business? Bring it over so
						you don&apos;t start from scratch. Pick where your work lives —
						I&apos;ll copy a prompt and open it for you.
					</p>

					<ProviderPickList
						websiteUrl={websiteUrl}
						instagramHandle={instagramHandle}
						onPick={onPick}
					/>

					<button
						type="button"
						onClick={onSkip}
						style={{
							background: 'none',
							border: 'none',
							padding: 0,
							cursor: 'pointer',
							color: 'var(--text-muted)',
							fontSize: 14,
							textDecoration: 'underline',
						}}
					>
						Skip — start fresh
					</button>
				</div>
			</div>
		</div>
	);
};
